import React from 'react';
import { SelectItem } from '../Select.types'

interface SubCategoriesListProps {
  name: string;
  backLabel?: string;
  onClickBack?: () => void;
  list: SelectItem[];
  onSelect: (item: SelectItem) => void;
}

export const SubCategoriesList = ({
  name,
  backLabel,
  onClickBack,
  list,
  onSelect,
}: SubCategoriesListProps) => {
  return (
    <div>
      <li onClick={onClickBack} key={-1}>
        <span>
          <i className='icon-angle-left' />
          {backLabel || 'Back'}
        </span>
      </li>
      {...list.map((item, index) => (
        <li key={index} onClick={() => onSelect(item)}>
          {item[name]}
        </li>
      ))}
    </div>
  );
};
